var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.91,
    height: 13.333,
    viewBox: "0 0 10.91 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-bin-7215099",
    d: "M286.88,205.616h-2.917l-.4-1.616h-4.267l-.4,1.616H275.97v.808h1.212v10.909h8.485V206.424h1.212Zm-6.263,9.9h-.808v-8.081h.808Zm2.424,0h-.808v-8.081h.808Zm-3.119-10.707h3.006l.2.808h-3.41Z",
    transform: "translate(-275.97 -204)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin1);
export default __webpack_public_path__ + "static/media/bin-1.5f513a9971ed9e8470d449b402b81ea3.svg";
export { ForwardRef as ReactComponent };